import styled from 'styled-components'
import {Card} from 'react-bootstrap'
import {TbLocationFilled as LocationIcon} from 'react-icons/tb'
import {BsBookHalf as BookIcon} from 'react-icons/bs'
import LibraryTextWithIcon from './LibraryTextWithIcon'
import utils from '../../../common/utils'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import ColSpacer from '../../../common/styles/ColSpacer'
import LibraryResponse from '../near/LibraryNearResponse'
import breakpoints from '../../../config/Breakpoints'
import ColorConfig from '../../../config/ColorConfig'
import React from "react";
import BooksitoutIcon from "../../../config/BooksitoutIcon";

const LibraryCard: React.FC<{
    library: LibraryResponse
    ranking?: number | null
    backgroundColorType?: 'card' | 'card-card'
}> = ({ library, ranking, backgroundColorType }) => {
	if (library == null) return <></>

	return (
		<a href={`/library/${library.id}`}>
			<Container>
				<CardBodyContentContainer backgroundColorType={backgroundColorType ?? 'card'}>
					<Row>
						<ColSpacer size={2.5} />
						<LibraryNameContainer className={library.location.distance !== 0 ? 'col-8' : 'col-12'}>
							<LibraryImage src={library.location.logo} />
							<ColSpacer size={5} />
							<LibraryName>{library.name}</LibraryName>
						</LibraryNameContainer>

						{library.location.distance !== 0 && (
							<Col4>
								<h5 className="text-end" style={{color: 'var(--text-color)'}}>
									{library.location.distance?.toFixed(library.location.distance >= 20 ? 0 : 1) ?? '-'} km
								</h5>
							</Col4>
						)}

                        {ranking && <RankingBadge>{library.ranking}</RankingBadge>}
                    </Row>

					<LibraryInfoContainer>
						<LibraryTextWithIcon icon={<LocationIcon />} text={library.location.address} />
						<LibraryTextWithIcon icon={<BookIcon />} text={library.bookCount === 0 ? '-' : `${utils.insertCommas(library.bookCount)} 권`} />

                        {
                            library.isOpenNow != null &&
						        <LibraryTextWithIcon icon={library.isOpenNow ? <BooksitoutIcon.timeOpen/> : <BooksitoutIcon.timeClosed/>} text={library.isOpenNow ? `OPEN` : `CLOSED, ${library.closedReason}`} />
                        }
					</LibraryInfoContainer>
				</CardBodyContentContainer>
			</Container>
		</a>
	)
}

const Container = styled(Card).attrs({
	className: 'mb-3',
})`
	min-height: 125px;
`

const Row = styled.div.attrs({
	className: 'row',
})``

const Col4 = styled.div.attrs({
	className: 'col-4',
})``

const LibraryNameContainer = styled.div`
	display: flex;
	align-items: center;
`

const LibraryName = styled.h4.attrs({
	className: 'clamp-1-line',
})`
	padding-top: 5px;
    color: var(--text-color);
`

const LibraryImage = styled.img.attrs({
	className: 'img-fluid',
})`
	width: 35px;
`

const LibraryInfoContainer = styled.div`
	margin-left: 50px;

	@media screen and (max-width: ${breakpoints.md}) {
		margin-left: 25px;
	}
`

const RankingBadge = styled.div`
    position: absolute;
    bottom: 10px;
	right: 5px;
	min-width: 25px;
	max-width: 25px;
	height: 25px;
	background-color: ${ColorConfig.Primary};
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 25px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	margin-right: 10px;
`

export default LibraryCard
